import * as React from "react";
import { isMobile } from "react-device-detect";
import { connect } from "react-redux";
import { Alert } from "reactstrap";
import { Action, Dispatch } from "redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IMessageToasterAction } from "Store/MessageToaster/MessageToasterAction";
import { IMessageToasterState } from "Store/MessageToaster/MessageToasterActionTypes";
import { IApplicationState } from "Store/Store";
import styles from "./MessageToaster.scss";

const messageToasterAction = ServiceProvider.get<IMessageToasterAction>(Types.IMessageToasterAction);

const mapStateToProps = (state: IApplicationState) => ({
    messageState: state.messageToasterState
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    clearMessage: () => dispatch(messageToasterAction.clearMessage())
});

interface IProps {
    messageState: IMessageToasterState;
    clearMessage(): Action;
}

interface IState {
    messageState: IMessageToasterState;
    visible: boolean;
}

export class MessageToaster extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            messageState: {},
            visible: false
        };
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState | null> {
        return nextProps.messageState === prevState.messageState ?
            null : { messageState: nextProps.messageState, visible: true };
    }

    private onDismiss: () => void = () => {
        this.setState({ visible: false });
        this.props.clearMessage();
    }

    public checkVisibility = (): boolean => {
        if (this.state.visible) {
            setTimeout(() => {
                this.setState({ visible: false });
            }, 2000);
            return true;
        }

        return false;
    }

    public render() {
        return (
            <>
                {this.state.messageState.message &&
                    <Alert
                        id="mtrAlert"
                        className={`${styles.message} ${isMobile ? styles.messageIsMobile : ""}`}
                        color={this.state.messageState.message.type}
                        isOpen={this.checkVisibility()}
                        toggle={() => this.onDismiss()}>
                        {this.state.messageState.message.text}
                    </Alert>
                }
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageToaster);


// WEBPACK FOOTER //
// ./src/Components/MessageToaster/MessageToaster.tsx